"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgPageDef_definitionPayloadMaxChars = exports.OrgPageDefActionType = void 0;
var OrgPageDefActionType;
(function (OrgPageDefActionType) {
    OrgPageDefActionType["UpsertPageDef"] = "UpsertPageDef";
    OrgPageDefActionType["RemovePageDef"] = "RemovePageDef";
    OrgPageDefActionType["PatchPageDef"] = "PatchPageDef";
})(OrgPageDefActionType = exports.OrgPageDefActionType || (exports.OrgPageDefActionType = {}));
/**
 * Max char length of the json-stringified TaskRunnerOrgExpiringPageDefActionArgs payload sent to the backend api.
 */
// todo: broken: wip removing. use data-size-limits
exports.OrgPageDef_definitionPayloadMaxChars = 1024 * 64 * 2.2;
//# sourceMappingURL=org-expiring-page-def.js.map